import { createFieldSelectorHook } from 'src/lib/sweetState';

// @ts-expect-error - ProjectStore does not have types yet
import { ProjectStore } from './ProjectStore';

export const useCurrentProject = createFieldSelectorHook(ProjectStore, 'currentProject');
